import Image from 'next/image';
import image from 'app/assets/media/ellipse-blur-green-small.png';

export default function EllipseBlur() {
  return (
    <div className="relative pb-[100%]">
      <Image
        src={image}
        alt="Пилатес-студия РМК"
        quality={100}
        sizes="(min-width: 768px) 50vw, (min-width: 1280px) 25vw, 100vw"
        fill
        className="object-contain"
      />
    </div>
  );
}
